// extracted by mini-css-extract-plugin
export default {"solidStar":"StarRating_solidStar__yfcs9","hollowStar":"StarRating_hollowStar__StfgW"};